import { Instagram, Phone, MapPin } from "lucide-react";

function TikTokIcon({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M9 18a4 4 0 1 1 0-8" />
      <path d="M13 4v10a4 4 0 0 1-4 4" />
      <path d="M13 4c1 3 3 5 6 5" />
    </svg>
  );
}

function YouTubeIcon({ size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="6" width="18" height="12" rx="3" />
      <path d="m10 9 5 3-5 3V9z" />
    </svg>
  );
}

export default function Footer() {
  return (
    <footer className="bg-white border-t border-stone-200 mt-12 px-5 md:px-10 py-10">
      <div className="grid md:grid-cols-3 gap-10 text-center items-start">
        <div className="flex flex-col items-center">
          <img
            src="/sevinc-logo.png"
            alt="Sevinç Outdoor"
            className="h-16 sm:h-20 w-auto object-contain mb-4"
          />

          <img
            src="/sevinc-grup.png"
            alt="Sevinç Grup"
            className="h-20 sm:h-24 w-auto object-contain mb-3"
          />

          <p className="text-sm font-medium text-stone-700">
            <b>Sevinç Grup kuruluşudur.</b>
          </p>

          <p className="text-stone-500 mt-2">
            Keskin Çözüm, Güvenilir Hizmet
          </p>
        </div>

        <div className="flex flex-col items-center">
          <h4 className="font-bold text-lg mb-3">İletişim</h4>

          <p className="flex items-center gap-2 text-stone-700">
            <Phone size={16} />
            +90 531 749 14 56
          </p>

          <p className="flex items-center gap-2 mt-2 text-stone-700">
            <MapPin size={16} />
            Denizli / Türkiye
          </p>
        </div>

        <div className="flex flex-col items-center">
          <h4 className="font-bold text-lg mb-3">Sosyal Medya</h4>

          <div className="flex gap-3">
            <a
              href="https://www.instagram.com/sevinc.bicak/"
              target="_blank"
              rel="noreferrer"
              className="p-3 bg-soft rounded-full hover:bg-stone-100 transition"
              aria-label="Instagram"
            >
              <Instagram size={18} />
            </a>

            <a
              href="https://www.tiktok.com/@svnc.bck"
              target="_blank"
              rel="noreferrer"
              className="p-3 bg-soft rounded-full hover:bg-stone-100 transition"
              aria-label="TikTok"
            >
              <TikTokIcon size={18} />
            </a>

            <a
              href="https://www.youtube.com/@sevinc.bicak"
              target="_blank"
              rel="noreferrer"
              className="p-3 bg-soft rounded-full hover:bg-stone-100 transition"
              aria-label="YouTube"
            >
              <YouTubeIcon size={18} />
            </a>
          </div>
        </div>
      </div>

      <div className="mt-8 border-t pt-6 text-center text-sm text-stone-500">
        © 2026 Sevinç Outdoor. Tüm hakları saklıdır.
      </div>
    </footer>
  );
}